import React, { useState, useMemo } from "react";
import { Search, Calendar, FileDown, Clock, X } from "lucide-react";
import DashboardLayout from "../components/layout/index";

const AFTERNOON_SLOTS = ["11:00 AM", "11:15 AM", "11:30 AM", "12:00 PM", "12:15 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM"];

const SAMPLE_SLOTS = [
  { id: 1, doctorName: "Dr. Nainika", date: "08/12/2025", startTime: "12:00 PM", endTime: "2:00 PM", duration: "15 mins", consultationType: "In-person", bookedSlots: 3 },
  { id: 2, doctorName: "Dr. Nainika", date: "08/12/2025", startTime: "4:00 PM", endTime: "6:00 PM", duration: "15 mins", consultationType: "Video", bookedSlots: 2 },
  { id: 3, doctorName: "Dr. Nainika", date: "09/12/2025", startTime: "12:00 PM", endTime: "2:00 PM", duration: "15 mins", consultationType: "In-person", bookedSlots: 3 },
  { id: 4, doctorName: "Dr. Nainika", date: "09/12/2025", startTime: "4:00 PM", endTime: "6:00 PM", duration: "15 mins", consultationType: "Video", bookedSlots: 2 },
  { id: 5, doctorName: "Dr. Nainika", date: "10/12/2025", startTime: "12:00 PM", endTime: "2:00 PM", duration: "15 mins", consultationType: "In-person", bookedSlots: 3 },
  { id: 6, doctorName: "Dr. Nainika", date: "10/12/2025", startTime: "4:00 PM", endTime: "6:00 PM", duration: "15 mins", consultationType: "Video", bookedSlots: 2 },
  { id: 7, doctorName: "Dr. Nainika", date: "11/12/2025", startTime: "12:00 PM", endTime: "2:00 PM", duration: "15 mins", consultationType: "In-person", bookedSlots: 3 },
  { id: 8, doctorName: "Dr. Nainika", date: "11/12/2025", startTime: "4:00 PM", endTime: "6:00 PM", duration: "15 mins", consultationType: "Video", bookedSlots: 2 },
  { id: 9, doctorName: "Dr. Nainika", date: "12/12/2025", startTime: "12:00 PM", endTime: "2:00 PM", duration: "15 mins", consultationType: "In-person", bookedSlots: 3 },
  { id: 10, doctorName: "Dr. Nainika", date: "12/12/2025", startTime: "4:00 PM", endTime: "6:00 PM", duration: "15 mins", consultationType: "Video", bookedSlots: 2 },
];

const PAGE_SIZE = 10;
const DURATION_OPTIONS = ["This Week", "This Month", "Custom"];

function CurebaySlotManagement() {
  const [doctorNameFilter, setDoctorNameFilter] = useState("Dr. Nainika");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [durationFilter, setDurationFilter] = useState("This Week");
  const [fromDate, setFromDate] = useState("2025-12-08");
  const [toDate, setToDate] = useState("2025-12-15");
  const [page, setPage] = useState(1);

  const [manageSlotOpen, setManageSlotOpen] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [slotFromDate, setSlotFromDate] = useState("2025-12-08");
  const [slotToDate, setSlotToDate] = useState("2025-12-08");
  const [slotStartTime, setSlotStartTime] = useState("11:00 AM");
  const [slotEndTime, setSlotEndTime] = useState("12:00 PM");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("11:00 AM");

  const filteredRows = useMemo(() => {
    return SAMPLE_SLOTS.filter((row) => {
      const matchDoctor =
        !doctorNameFilter ||
        row.doctorName.toLowerCase().includes(doctorNameFilter.toLowerCase());
      return matchDoctor;
    });
  }, [doctorNameFilter]);

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const visibleRows = filteredRows.slice(startIndex, startIndex + PAGE_SIZE);

  const handleExport = () => {
    // eslint-disable-next-line no-alert
    alert("Export to Excel will be implemented with backend API.");
  };

  const openManageSlot = (row) => {
    setSelectedSlot(row);
    setSlotFromDate(row.date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1"));
    setSlotToDate(row.date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1"));
    setSlotStartTime(row.startTime);
    setSlotEndTime(row.endTime);
    setSelectedTimeSlot(row.startTime);
    setManageSlotOpen(true);
  };

  const closeManageSlot = () => {
    setManageSlotOpen(false);
    setSelectedSlot(null);
  };

  const handleChangeSlot = () => {
    // Placeholder – wire to API later
    closeManageSlot();
  };

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-white p-4 md:p-6 lg:p-8">
        <div className="mb-6 flex items-center gap-2">
         
          <h1 className="text-xl md:text-2xl font-semibold text-[#004276]">
            Slot Management
          </h1>
        </div>

        {/* Filters */}
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm mb-6">
          <h2 className="text-base font-semibold text-[#004276] mb-4">
            Search & filter
          </h2>
          <div className="flex flex-wrap items-end gap-4 lg:gap-5">
            <div className="w-full sm:w-[200px] lg:w-[220px]">
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Doctor Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Enter Doctor Name"
                  value={doctorNameFilter}
                  onChange={(e) => {
                    setDoctorNameFilter(e.target.value);
                    setPage(1);
                  }}
                  className="w-full rounded-lg border border-gray-300 bg-white pl-4 pr-10 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent"
                />
                <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
              </div>
            </div>

            <div className="w-full sm:w-[220px] lg:w-[260px]">
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Department / Specialization
              </label>
              <input
                type="text"
                placeholder="Select Department/Specialization"
                value={departmentFilter}
                onChange={(e) => setDepartmentFilter(e.target.value)}
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent"
              />
            </div>

            <div className="flex flex-wrap items-end gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Duration
                </label>
                <select
                  value={durationFilter}
                  onChange={(e) => setDurationFilter(e.target.value)}
                  className="rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent min-w-[140px]"
                >
                  {DURATION_OPTIONS.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex items-center gap-2">
                <div className="relative">
                  <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="rounded-lg border border-gray-300 bg-white pl-10 pr-3 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent w-[140px]"
                  />
                </div>
                <span className="text-gray-400 font-medium">–</span>
                <div className="relative">
                  <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="rounded-lg border border-gray-300 bg-white pl-10 pr-3 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#004276] focus:border-transparent w-[140px]"
                  />
                </div>
              </div>
            </div>

            <div className="w-full sm:w-auto sm:ml-auto">
              <button
                type="button"
                onClick={handleExport}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#004276] text-white text-sm font-medium shadow-sm hover:bg-[#00325a] focus:outline-none focus:ring-2 focus:ring-[#004276] focus:ring-offset-2 transition-colors"
              >
                <FileDown className="w-4 h-4" />
                Export to excel
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="rounded-xl border border-gray-200 bg-white overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-[#F8FAFC]">
                <tr>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Doctor Name
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Date
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Start time
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    End time
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Duration
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Consultation Type
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Booked Slots
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-600">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {visibleRows.length === 0 ? (
                  <tr>
                    <td
                      colSpan={8}
                      className="px-6 py-8 text-center text-gray-500"
                    >
                      No slots found.
                    </td>
                  </tr>
                ) : (
                  visibleRows.map((row) => (
                    <tr key={row.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 text-gray-900 font-medium">
                        {row.doctorName}
                      </td>
                      <td className="px-6 py-4 text-gray-700">{row.date}</td>
                      <td className="px-6 py-4 text-gray-700">
                        {row.startTime}
                      </td>
                      <td className="px-6 py-4 text-gray-700">{row.endTime}</td>
                      <td className="px-6 py-4 text-gray-700">
                        {row.duration}
                      </td>
                      <td className="px-6 py-4 text-gray-700">
                        {row.consultationType}
                      </td>
                      <td className="px-6 py-4 text-gray-700">
                        {row.bookedSlots}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          type="button"
                          onClick={() => openManageSlot(row)}
                          className="text-[#004276] hover:text-[#00325a] font-medium underline focus:outline-none"
                        >
                          Manage Slots
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {filteredRows.length > PAGE_SIZE && (
            <div className="flex items-center justify-between px-6 py-3 border-t border-gray-200 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  disabled={currentPage === 1}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  className={`px-2 py-1 ${
                    currentPage === 1
                      ? "text-gray-400 cursor-not-allowed"
                      : "text-[#004276] hover:underline"
                  }`}
                >
                  &lt; Prev
                </button>
                <span className="px-2">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  type="button"
                  disabled={currentPage === totalPages}
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  className={`px-2 py-1 ${
                    currentPage === totalPages
                      ? "text-gray-400 cursor-not-allowed"
                      : "text-[#004276] hover:underline"
                  }`}
                >
                  Next &gt;
                </button>
              </div>
              <div>
                Showing {startIndex + 1} to{" "}
                {Math.min(startIndex + PAGE_SIZE, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </div>
            </div>
          )}
        </div>

        {/* Manage Consultation Slots – right-side panel (sidebar stays visible on left) */}
        {manageSlotOpen && selectedSlot && (
          <>
            <div
              className="fixed inset-0 md:left-64 z-40 bg-black/50"
              role="presentation"
              aria-hidden="true"
              onClick={closeManageSlot}
            />
            <div
              className="fixed right-0 top-0 bottom-0 z-50 w-full max-w-md bg-white shadow-2xl overflow-y-auto"
              role="dialog"
              aria-modal="true"
              aria-labelledby="manage-slots-title"
            >
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h2 id="manage-slots-title" className="text-xl font-semibold text-[#004276]">
                      Manage Consultation Slots
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                      Update doctor availability for selected date.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={closeManageSlot}
                    className="p-1 rounded-lg text-gray-500 hover:bg-gray-100 focus:outline-none"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                <p className="text-sm text-gray-700 mb-4">
                  <span className="font-medium">Current Slot, Date / Time:</span>{" "}
                  {selectedSlot.date} ; {selectedSlot.startTime} to {selectedSlot.endTime}
                </p>

                <div className="border-t border-dashed border-gray-300 pt-4 mt-4">
                  <h3 className="text-sm font-semibold text-[#004276] mb-3">Select Date</h3>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        From Date <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                        <input
                          type="date"
                          value={slotFromDate}
                          onChange={(e) => setSlotFromDate(e.target.value)}
                          className="w-full rounded-lg border border-gray-300 bg-white pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#004276]"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        To Date <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                        <input
                          type="date"
                          value={slotToDate}
                          onChange={(e) => setSlotToDate(e.target.value)}
                          className="w-full rounded-lg border border-gray-300 bg-white pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#004276]"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-t border-dashed border-gray-300 pt-4 mt-4">
                  <h3 className="text-sm font-semibold text-[#004276] mb-3">Update Availability</h3>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Select Start Time
                      </label>
                      <div className="relative">
                        <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                        <input
                          type="text"
                          value={slotStartTime}
                          onChange={(e) => setSlotStartTime(e.target.value)}
                          className="w-full rounded-lg border border-gray-300 bg-white pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#004276]"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Select End Time
                      </label>
                      <div className="relative">
                        <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                        <input
                          type="text"
                          value={slotEndTime}
                          onChange={(e) => setSlotEndTime(e.target.value)}
                          className="w-full rounded-lg border border-gray-300 bg-white pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#004276]"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="bg-green-100 text-green-800 text-sm font-medium px-3 py-2 rounded-t-lg">
                      Afternoon
                    </div>
                    <div className="flex flex-wrap gap-2 p-3 border border-t-0 border-gray-200 rounded-b-lg bg-gray-50">
                      {AFTERNOON_SLOTS.map((time) => (
                        <button
                          key={time}
                          type="button"
                          onClick={() => {
                            setSelectedTimeSlot(time);
                            setSlotStartTime(time);
                          }}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            selectedTimeSlot === time
                              ? "bg-[#004276] text-white"
                              : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-100"
                          }`}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={handleChangeSlot}
                  className="w-full py-3 rounded-lg bg-[#004276] text-white font-medium hover:bg-[#00325a] focus:outline-none focus:ring-2 focus:ring-[#004276] focus:ring-offset-2 transition-colors"
                >
                  Change Slot
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  );
}

export default CurebaySlotManagement;
